import { Injectable } from "@angular/core";
import { interval, Subscription } from "rxjs";

@Injectable()
export class ProgressBarService {
    progress = 0;
    private intervalSubscription: Subscription | null = null; 
    private finalInterval: Subscription | null = null; 

    constructor() { }

    startProgress() {
        if(!!this.intervalSubscription){
            return;
        }
        this.intervalSubscription = interval(100).subscribe(() => {
            if (this.progress < 95) {
                this.progress += 1;
            } else {
                this.unsubscribeMainInterval();
            }
        });
    }

    completeProgress() {
        this.unsubscribeMainInterval();
        if(!!this.finalInterval){
            return;
        }
        this.finalInterval = interval(30).subscribe(() => {
          if (this.progress <= 100) {
            this.progress += 2;
          } else {
            this.resetProgress();
            this.unsubscribeFinalInterval();
          }
        });
    }

    private unsubscribeMainInterval() {
        if (!!this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
            this.intervalSubscription = null;
        }
    }

    private unsubscribeFinalInterval() {
        this.finalInterval.unsubscribe();
        this.finalInterval = null;
    }
    
    private resetProgress(): void {
        this.progress = 0;
    }
}